import { render, staticRenderFns } from "./TeamsMain.vue?vue&type=template&id=03eb1074&"
import script from "./TeamsMain.vue?vue&type=script&setup=true&lang=js&"
export * from "./TeamsMain.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports